// extracted by mini-css-extract-plugin
export default {"wrap":"Checkbox_wrap__PKAU-","input":"Checkbox_input__LrtFn","box":"Checkbox_box__WPVIe","label":"Checkbox_label__8lDkA","disabled":"Checkbox_disabled__iEOK8"};